import { PriceListFilterInput, PriceListQuery } from "@/gql/graphql";
import { gql, useQuery } from "@apollo/client";

export const priceListQuery = gql`
  query PriceList($filter: PriceListFilterInput!) {
    priceList {
      byFilter(filter: $filter) {
        priceListRows {
          routeAgreementNumber
          routeAgreementName
          routeAgreementVehicleType
          routeAgreementCurrency
          customerNumber
          customerIndex
          validFrom
          validTo
          route
          sailingCategory
          vehicleType
          movementType
          length
          price
          convertedPrice
          weightFrom
          weightTo
          unaccompanied
        }
      }
    }
  }
`;

const noRows: PriceListQuery["priceList"]["byFilter"]["priceListRows"] = [];

export const useFetchPriceList = (filter: PriceListFilterInput | undefined) => {
  const { data, loading, error } = useQuery<
    PriceListQuery,
    { filter: PriceListFilterInput }
  >(priceListQuery, {
    variables: filter ? { filter } : undefined,
    skip: !filter,
    fetchPolicy: "cache-and-network",
  });

  return {
    rows: data?.priceList.byFilter.priceListRows ?? noRows,
    loading,
    error,
  };
};
